<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="工作总结维护" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="工作总结维护">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="工作总结编号">
                                            <a-input ref="gzzjjlbh" v-model="editData.gzzjjlbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="总结日期">
                                            <a-input ref="zjrq" v-model="editData.zjrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="总结年份">
                                            <FGDictSelect ref="zjnf" dictNo="1111" v-model="editData.zjnf" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="单位类型">
                                            <FGDictSelectCN ref="dwlx" dictNo="DW100101" v-model="editData.dwlx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位类别">
                                            <FGDictSelectCN ref="dwlb" dictNo="DW100102" v-model="editData.dwlb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="区域编号">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="行业分类">
                                            <a-input ref="hyfl" v-model="editData.hyfl" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="单位性质">
                                            <a-input ref="dwxz" v-model="editData.dwxz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="9">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="录入日期">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="18">
                                        <a-form-item label="总结内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="zjnr" :rows="3" v-model="editData.zjnr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="18">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");

export default {
    name: "GzzjwhForm",
    props: ["showForm", "dataId"],

    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "详情";
        },
        // 是否显示详情界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "NJ_GZZJJL",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "NJ2000"
            };
        }
    },
    activated() {
        //加载数据
        this.loadData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/gzzjgl/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },

        //撤销
        unSubmit(type) {
            this.$FG_http
                .post("./api/main/dwdcgl/gzzjgl/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
